export default __webpack_public_path__ + "static/media/DINNextLTPro-Regular.6aac35b5.woff2";